import { ConfirmDialog, Money } from "../../../../components/ui";
import { businessApi } from "../../../../services/api";
import { paymentOf, periodLabel } from "./payslipView";

/**
 * ConfirmReceiptDialog — the employee confirms actually receiving their salary (FIN-2, PAY-7). The server decides
 * whether it can be confirmed: only their own salary, only after Finance recorded the handover. A refusal stays in
 * the dialog in the server's own words so they can try again or close.
 */
export default function ConfirmReceiptDialog({ payslip, onClose, onConfirmed }) {
  const payment = paymentOf(payslip);
  const period = periodLabel(payslip);

  const confirm = async () => {
    const result = await businessApi.confirmMySalaryReceipt(payslip.id);
    onConfirmed({ payslip, amountCents: payment.amountCents, alreadyConfirmed: Boolean(result?.alreadyConfirmed) });
  };

  return (
    <ConfirmDialog
      title="Confirm salary received"
      confirmLabel="Yes, I received it"
      failureTitle="Not confirmed"
      errorFallback="Your confirmation was not saved. Check your connection and try again."
      onConfirm={confirm}
      onClose={onClose}
    >
      <p className="text-body text-foreground">
        You are confirming that you received <Money value={payment.amountCents} className="font-semibold" /> in cash for {period}.
      </p>
      <p>Confirm only when the money is in your hands. This marks your salary as paid.</p>
      <p>It does not change your payslip or how your pay was calculated.</p>
    </ConfirmDialog>
  );
}
